import { inject, Injectable, Injector } from '@angular/core';

import { createProviderToken, provide } from '@core/common-legacy';
import { HttpApiService } from '@core/http-legacy';
import { HttpApiRequestOptions, HttpRequestData } from '@core/http-types';
import { TellentAdminRequestData } from '@core/tellent-http-legacy';

@Injectable()
export class TellentAskRequestData extends TellentAdminRequestData {
  public buildUrl(path: string, requestOptions: HttpApiRequestOptions): string {
    return `${this.config.tellentApiUrl}${
      requestOptions.skipCompany ? '' : '/ask/org/' + this.orgGuid
    }${path.replace('/views', '')}`;
  }
}

export const { inject: injectTellentAskHttp } = createProviderToken('TellentAskHttp')(false, {
  providedIn: 'root',
  factory: () =>
    Injector.create({
      providers: [
        provide(HttpApiService, { useClass: HttpApiService }),
        provide(HttpRequestData, { useClass: TellentAskRequestData }),
      ],
      parent: inject(Injector),
    }).get(HttpApiService),
});
